import { loadGLightbox } from "common/glightbox-loader";

import "./jiffymade-landing-gallery.scss";

const $getImages = () => document.querySelectorAll(".js-jiffymade-landing-jiffy-image");

const loadImage = src =>
  new Promise(resolve => {
    const image = new Image();
    image.src = src;
    image.onload = () => resolve();
  });

const SWAP_IMAGE_INTERVAL = 3000;
const FADE_IN_CLASS = "jiffymade-landing-gallery__image--fade-in";
const FADE_OUT_CLASS = "jiffymade-landing-gallery__image--fade-out";
const ALL_IMAGES = [
  "https://jiffy.imgix.net/gen/jiffymade-landing/create-jiffy/create-with-jiffy-1.png",
  "https://jiffy.imgix.net/gen/jiffymade-landing/create-jiffy/create-with-jiffy-2.png",
  "https://jiffy.imgix.net/gen/jiffymade-landing/create-jiffy/create-with-jiffy-3.jpeg",
  "https://jiffy.imgix.net/gen/jiffymade-landing/create-jiffy/create-with-jiffy-4.png",
  "https://jiffy.imgix.net/gen/jiffymade-landing/create-jiffy/create-with-jiffy-5.jpeg",
  "https://jiffy.imgix.net/gen/jiffymade-landing/create-jiffy/create-with-jiffy-6.jpeg",
  "https://jiffy.imgix.net/gen/jiffymade-landing/reviews/2.png",
  "https://jiffy.imgix.net/gen/jiffymade-landing/reviews/3.png",
  "https://jiffy.imgix.net/gen/jiffymade-landing/reviews/4.png",
  "https://jiffy.imgix.net/gen/jiffymade-landing/reviews/5.png",
  "https://jiffy.imgix.net/gen/jiffymade-landing/reviews/6.png",
  "https://jiffy.imgix.net/gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-7.png",
  "https://jiffy.imgix.net/gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-8.png",
  "https://jiffy.imgix.net/gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-9.png"
];
const IMGIX_PARAMS_FULL_IMAGE = "?ixlib=rb-0.3.5&auto=format";
const IMGIX_PARAMS_THUMBNAIL = "?ixlib=rb-0.3.5&auto=format&h=800&dpr=1.5&q=80";

let lightbox;
const currentImages = Array.from($getImages()).map($image => $image.src.split("?")[0]);
const otherImages = ALL_IMAGES.filter(image => !currentImages.includes(image));
const loadPromises = currentImages.map(image => loadImage(`${image}${IMGIX_PARAMS_THUMBNAIL}`));

const showLightbox = index => {
  lightbox?.openAt(index);
};

const swapRandomImage = () => {
  const previousImageIndex = Math.floor(Math.random() * currentImages.length);
  const newImageIndex = Math.floor(Math.random() * otherImages.length);

  const newImage = otherImages[newImageIndex];
  const newImageSrc = `${newImage}${IMGIX_PARAMS_THUMBNAIL}`;

  if (currentImages.includes(newImage)) {
    return swapRandomImage();
  }

  otherImages[newImageIndex] = currentImages[previousImageIndex];
  currentImages[previousImageIndex] = newImage;

  const promise = loadPromises[newImage] || (loadPromises[newImage] = loadImage(newImageSrc));

  return promise.then(() => {
    const $images = $getImages();
    const $imageToSwap = $images[previousImageIndex];
    $imageToSwap.classList.remove(FADE_IN_CLASS);
    $imageToSwap.classList.add(FADE_OUT_CLASS);
    $imageToSwap.src = newImageSrc;
    return new Promise(resolve =>
      // eslint-disable-next-line no-promise-executor-return
      setTimeout(() => {
        $imageToSwap.classList.remove(FADE_OUT_CLASS);
        $imageToSwap.classList.add(FADE_IN_CLASS);
        resolve();
      }, 300)
    );
  });
};

const initGLightbox = () => {
  const initializeGLightbox = () => {
    lightbox = window?.GLightbox({
      elements: ALL_IMAGES.map(image => ({
        href: `${image}${IMGIX_PARAMS_FULL_IMAGE}`,
        type: "image"
      })),
      touchNavigation: true,
      loop: false,
      autoplayVideos: false
    });
  };

  loadGLightbox(initializeGLightbox);
};

const initImageSwap = () => {
  Promise.all(loadPromises).then(() => {
    const swap = () => {
      setTimeout(async () => {
        await swapRandomImage();
        swap();
      }, SWAP_IMAGE_INTERVAL);
    };
    swap();
  });
};

export const initGallery = () => {
  initGLightbox();
  $getImages().forEach(($image, index) => {
    $image.addEventListener("click", () => {
      const currentImage = currentImages[index];
      const imageIndex = ALL_IMAGES.indexOf(currentImage);
      if (imageIndex !== -1) {
        showLightbox(imageIndex);
      }
    });
  });

  initImageSwap();
};

export default initGallery;
